export default __webpack_public_path__ + "static/media/can.cdcacda4.png";